<template>
  <div class="Notifications">
    <el-card class="box-card">
      <p class="title">Set Trigger</p>

      <div style="display: flex; justify-content: flex-end;">
        <el-button type="primary" size="mini" @click="openSetTriggerDialog(); clearSetTriggerForm()">ADD</el-button>
      </div>

      <el-row :gutter="20" class="p-2 flex items-center">
        <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
          <p class="text-xs">Location</p>
          <el-select v-model="store" multiple collapse-tags style="width: 100%;" @change="getAllNotificationList()" filterable>
            <el-option
                v-for="(store, index) in storeList"
                :key="index"
                :value="store.id"
                :label="store.name"
                style="text-transform: capitalize;"
              >
              </el-option>
          </el-select>
          <!-- <base-locations-dropdown class="mdms" @update="getNotificationTriggersByStore()" /> -->
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card mt-5">
      <table>
        <thead>
          <tr style="border: none;">
            <th>STORE NAME</th>
            <th>NOTIFICATION TYPE</th>
            <th colspan="2">SALES TARGET</th>
            <th colspan="2">TRANSACTIONS TARGET</th>
            <th colspan="2">SALES FORECAST</th>
            <th colspan="2">TRANSACTIONS FORECAST</th>
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>BELOW</th>
            <th>OVER</th>
            <th>BELOW</th>
            <th>OVER</th>
            <th>BELOW</th>
            <th>OVER</th>
            <th>BELOW</th>
            <th>OVER</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody v-loading="">
          <tr v-for="(notification, notify_index) in notification_trigger_list" :key="notify_index">
            <td class="capitalize font-bold">
              {{ notification.store_name }}
            </td>
            <td>
              <div v-for="(not_type, type_index) in notification.notification_type" :key="type_index">
                <div class="capitalize mt-1">{{ not_type.type }}</div>
              </div>
            </td>
            <td>
              {{ notification.sales_target_lower_than ? notification.sales_target_lower_than + '%' : notification.sales_target_lower_than }}
            </td>
            <td>
              {{ notification.sales_target_greater_than ? notification.sales_target_greater_than + '%' : notification.sales_target_greater_than }}
            </td>
            <td>
              {{ notification.transactions_target_lower_than ? notification.transactions_target_lower_than + '%' : notification.transactions_target_lower_than }}
            </td>
            <td>
              {{ notification.transactions_target_greater_than ? notification.transactions_target_greater_than + '%' : notification.transactions_target_greater_than }}
            </td>
            <td>
              {{ notification.sales_forecast_lower_than ? notification.sales_forecast_lower_than + '%' : notification.sales_forecast_lower_than }}
            </td>
            <td>
              {{ notification.sales_forecast_greater_than ? notification.sales_forecast_greater_than + '%' : notification.sales_forecast_greater_than }}
            </td>
            <td>
              {{ notification.transactions_forecast_lower_than ? notification.transactions_forecast_lower_than + '%' : notification.transactions_forecast_lower_than }}
            </td>
            <td>
              {{ notification.transactions_forecast_greater_than ? notification.transactions_forecast_greater_than + '%' : notification.transactions_forecast_greater_than }}
            </td>
            <td>
              <img src="../../../assets/images/edit.png" @click="editSetNotification(notification)" class="cursor-pointer mr-2" width="18" alt="">
              <img src="../../../assets/images/delete-icon.png" class="cursor-pointer" width="18" alt="" @click="deleteSetNotification(notification)">
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!notification_trigger_list.length" style="text-align: center; font-size: 14px; font-weight: 600; color: #e29d5a; padding: 15px;">
        No data available
      </div>
    </el-card>

    <el-dialog
      title="Set Trigger"
      :visible.sync="set_trigger_dialog"
      width="80%"
      :before-close="handleClose">

      <div>
        <!-- select location, notification type, frequency section -->
        <el-row :gutter="15">
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
            <p class="text-xs">Select Location <span class="text-red-dark">*</span></p>
            <el-select v-model="location_for_trigger" name="Select location" @change="getUsersForNotification()" v-validate="'required'" size="medium" style="width: 100%;" filterable>
              <el-option
                v-for="(store, loc_index) in storeList"
                :key="loc_index"
                :value="store.id"
                :label="store.name"
                style="text-transform: capitalize;"
              >
              </el-option>
            </el-select>

            <span v-show="errors.has('Select location') && show_error_on_empty"
              class="text-red-dark text-xs mt-1">{{ errors.first("Select location") }}
            </span>
          </el-col>

          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
            <p class="text-xs">Notification Type <span class="text-red-dark">*</span></p>
            <el-select v-model="notification_type" name="Notification type" v-validate="'required'" multiple collapse-tags placeholder="Select" size="medium" style="width: 100%;">
              <el-option
                v-for="(item, not_index) in notification_type_list"
                :key="not_index"
                :label="item.type"
                :value="item.id"
              ></el-option>
            </el-select>

            <span v-show="errors.has('Notification type') && show_error_on_empty"
              class="text-red-dark text-xs mt-1">{{ errors.first("Notification type") }}
            </span>
          </el-col>

          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
            <p class="text-xs">Notification Frequency <span class="text-red-dark">*</span></p>
            <el-select v-model="notification_frequency" v-validate="'required'" placeholder="Select" name="Notification freq" size="medium" style="width: 100%;">
              <el-option
                v-for="(item, freq_index) in notification_frequency_list"
                :key="freq_index"
                :label="item.title"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <span v-show="errors.has('Notification freq') && show_error_on_empty"
              class="text-red-dark text-xs">{{ errors.first("Notification freq") }}
            </span>
          </el-col>
        </el-row>

        <!-- set trigger table -->
        <table class="mt-5" style="border: 1px solid #ddd;">
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th colspan="2">Target</th>
              <th>&nbsp;</th>
              <th colspan="2">Forecast</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border: none;">
              <td class="font-bold">SALES</td>
              <td style="width: 190px;">
                <p class="font-bold text-left" style="font-size: 9px; margin-bottom: 1px;">BELOW</p>
                <el-select v-model="sales_target_lower_than" name="Sales Target Below" placeholder="0%" size="mini" v-validate="'required'">
                  <el-option v-for="(item, item_index1) in impact" :key="item_index1" :label="item.title" :value="item.value"></el-option>
                </el-select>

                <span v-show="errors.has('Sales Target Below') && show_error_on_empty" class="text-red-dark text-xs float-left mt-1">
                  This field is required
                </span>
              </td>
              <td style="width: 190px;">
                <p class="font-bold text-left" style="font-size: 9px; margin-bottom: 1px;">OVER</p>
                <el-select v-model="sales_target_greater_than" name="Sales Target Over" placeholder="0%" size="mini" v-validate="'required'">
                  <el-option v-for="(item, item_index2) in impact" :key="item_index2" :label="item.title" :value="item.value"></el-option>
                </el-select>

                <span v-show="errors.has('Sales Target Over') && show_error_on_empty" class="text-red-dark text-xs float-left mt-1">
                  This field is required
                </span>
              </td>

              <td>&nbsp;</td>

              <td style="width: 190px;">
                <p class="font-bold text-left" style="font-size: 9px; margin-bottom: 1px;">BELOW</p>
                <el-select v-model="sales_forecast_lower_than" name="Sales Forecast Below" placeholder="0%" size="mini" v-validate="'required'">
                  <el-option v-for="(item, item_index3) in impact" :key="item_index3" :label="item.title" :value="item.value"></el-option>
                </el-select>

                <span v-show="errors.has('Sales Forecast Below') && show_error_on_empty" class="text-red-dark text-xs float-left mt-1">
                  This field is required
                </span>
              </td>
              <td style="width: 190px;">
                <p class="font-bold text-left" style="font-size: 9px; margin-bottom: 1px;">OVER</p>
                <el-select v-model="sales_forecast_greater_than" name="Sales Forecast Over" placeholder="0%" size="mini" v-validate="'required'">
                  <el-option v-for="(item, item_index4) in impact" :key="item_index4" :label="item.title" :value="item.value"></el-option>
                </el-select>

                <span v-show="errors.has('Sales Forecast Over') && show_error_on_empty" class="text-red-dark text-xs float-left mt-1">
                  This field is required
                </span>
              </td>
            </tr>

            <tr style="border: none;">
              <td class="text-xs font-bold">TRANSACTIONS</td>
              <td style="width: 190px;">
                <p class="font-bold text-left" style="font-size: 9px; margin-bottom: 1px;">BELOW</p>
                <el-select v-model="transactions_target_lower_than" name="Transaction Target Below" placeholder="0%" size="mini" v-validate="'required'">
                  <el-option v-for="(item, item_index5) in impact" :key="item_index5" :label="item.title" :value="item.value"></el-option>
                </el-select>

                <span v-show="errors.has('Transaction Target Below') && show_error_on_empty" class="text-red-dark text-xs float-left mt-1">
                  This field is required
                </span>
              </td>
              <td style="width: 190px;">
                <p class="font-bold text-left" style="font-size: 9px; margin-bottom: 1px;">OVER</p>
                <el-select v-model="transactions_target_greater_than" name="Transaction Target Over" placeholder="0%" size="mini" v-validate="'required'">
                  <el-option v-for="(item, item_index6) in impact" :key="item_index6" :label="item.title" :value="item.value"></el-option>
                </el-select>

                <span v-show="errors.has('Transaction Target Below') && show_error_on_empty" class="text-red-dark text-xs float-left mt-1">
                  This field is required
                </span>
              </td>

              <td>&nbsp;</td>

              <td style="width: 190px;">
                <p class="font-bold text-left" style="font-size: 9px; margin-bottom: 1px;">BELOW</p>
                <el-select v-model="transactions_forecast_lower_than" name="Transaction Forecast Below" placeholder="0%" size="mini" v-validate="'required'">
                  <el-option v-for="(item, item_index7) in impact" :key="item_index7" :label="item.title" :value="item.value"></el-option>
                </el-select>

                <span v-show="errors.has('Transaction Target Below') && show_error_on_empty" class="text-red-dark text-xs float-left mt-1">
                  This field is required
                </span>
              </td>
              <td style="width: 190px;">
                <p class="font-bold text-left" style="font-size: 9px; margin-bottom: 1px;">OVER</p>
                <el-select v-model="transactions_forecast_greater_than" placeholder="0%" size="mini" name="Transaction Forecast Over" v-validate="'required'">
                  <el-option v-for="(item, item_index8) in impact" :key="item_index8" :label="item.title" :value="item.value"></el-option>
                </el-select>

                <span v-show="errors.has('Transaction Forecast Over') && show_error_on_empty" class="text-red-dark text-xs float-left mt-1">
                  This field is required
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="flex mt-8">
          <p class="text-xs p-2 font-bold">
            <span style="border-bottom: 2px solid #e29d5a;">ADD USERS</span>
          </p>

          <el-select v-model="recipients" placeholder="Select Users" size="mini" class="ml-5" multiple style="width: 300px;">
          <el-option
            v-for="item in users_list"
            :key="item.id"
            :label="item.email"
            :value="item.id"
            >
            {{ item.email }}
          </el-option>
        </el-select>
        </div>

        <div>
          <table class="mt-5" style="border: 1px solid #ddd;">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
                <th>Email Id</th>
                <th>Mobile No</th>
              </tr>
            </thead>
            <tbody v-if="users_list.length">
              <tr v-for="(user, user_index) in users_list" :key="user_index">
                <td>{{ user.full_name }}</td>
                <td>{{ user.designation }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.phone_number }}</td>
              </tr>
            </tbody>
          </table>

          <div v-if="!users_list.length" style="text-align: center; font-size: 12px; font-weight: 600; color: #e29d5a; padding: 15px;">
            No data available
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="set_trigger_dialog = false">CANCEL</el-button>
        <el-button type="primary" size="mini" @click="saveNotificationTrigger()">SAVE</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BaseLocationsDropdown from "../../baseLocationsDD/BaseLocationsDD.vue";
import moment from "moment";
import RealTimeService from "../../../services/realTimeService";
import { EventBus } from "../../../eventBus";
export default {
  name: "Notifications",
  components: {
    BaseLocationsDropdown
  },
  data() {
    return {
      is_notification_trigger_list_loading: false,
      set_trigger_dialog: false,
      show_error_on_empty: false,

      location_for_trigger: '',
      notification_frequency: "",

      impact: [
        {
          title: '0%',
          value: 0
        },
        {
          title: '5%',
          value: 5
        },
        {
          title: '10%',
          value: 10
        },
        {
          title: '15%',
          value: 15
        },
        {
          title: '20%',
          value: 20
        },
        {
          title: '25%',
          value: 25
        },
        {
          title: '30%',
          value: 30
        },
        {
          title: '35%',
          value: 35
        },
        {
          title: '40%',
          value: 40
        },
        {
          title: '45%',
          value: 45
        },
        {
          title: '50%',
          value: 50
        },
        {
          title: '55%',
          value: 55
        },
        {
          title: '60%',
          value: 60
        },
        {
          title: '65%',
          value: 65
        },
        {
          title: '70%',
          value: 70
        },
        {
          title: '75%',
          value: 75
        },
        {
          title: '80%',
          value: 80
        },
        {
          title: '85%',
          value: 85
        },
        {
          title: '90%',
          value: 90
        },
        {
          title: '95%',
          value: 95
        },
        {
          title: '100%',
          value: 100
        },
      ],
      notification_trigger_list: [],
      storeList: [],
      store: [],
      notification_type: [],
      users_list: [],
      recipients: [],
      notification_type_list: [],
      notification_frequency_list: [
        {
          title: 'Hourly',
          value: 'Every Hour'
        },
        {
          title: 'End of day part',
          value: 'End Of Day Part'
        },
        {
          title: 'Every 6 hours',
          value: 'Every Six Hours'
        },
        // {
        //   title: 'End of day',
        //   value: 'end of day'
        // },
      ],

      sales_target_lower_than: 0,
      sales_target_greater_than: 0,
      sales_forecast_lower_than: 0,
      sales_forecast_greater_than: 0,
      transactions_target_lower_than: 0,
      transactions_target_greater_than: 0,
      transactions_forecast_lower_than: 0,
      transactions_forecast_greater_than: 0,
    };
  },
  created() {
    this.getNotificationTypeList();
    this.getStoreList();
  },
  mounted() {
    // EventBus.$on("changeLocationData", this.changeLocationData);
  },
  methods: {
    getStoreList() {
			RealTimeService.getAllStoreData().then(response => {
				let res = JSON.parse(response.data);
				this.storeList = res;
        this.storeList.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); // sort a-z store list

        // called function to get all notifications
        //called this function in success of getStoreList api,,because we have getting store name from getStoreList api
        this.getAllNotificationList();
			})
		},

    getAllNotificationList() {
      this.is_notification_trigger_list_loading = true;

      let params = {
        store_id : [(this.store).toString()]
      }

      RealTimeService.getNotificationData(this.store.length ? params : {})
        .then(response => {
          this.notification_trigger_list = JSON.parse(response.data);

          // let temp = [];

          // // if single or multiple stores selected in location dropdown then filtered notification resonse by that stores
          // //in response we have getting all notification...we have filtered them from here
          // if(this.store.length){
          //   this.store.forEach(store => {
          //     let filtered = notification_res.filter(e =>{
          //       return store == e.stores[0].id
          //     })
          //     temp.push(...filtered);
          //   });

          //   this.notification_trigger_list = temp;
          // }else{
          //   // if any store are not selected then displayed all noitifcation response
          //   this.notification_trigger_list = notification_res;
          // }
          // // console.log('temp', temp);

          if (this.notification_trigger_list.length) {
            // console.log(this.notification_trigger_list);
            for(var i=0; i<this.notification_trigger_list.length; i++){
              let storeObj = this.storeList.filter(store =>{
                return store.id == this.notification_trigger_list[i].stores[0].id;
              });

              this.$set(this.notification_trigger_list[i], 'store_name', storeObj.length ? storeObj[0].name : this.notification_trigger_list[i].stores[0].id);
            }
            this.is_notification_trigger_list_loading = false;
            // this.sales_target_lower_than = this.notification_trigger_list[0].sales_target_lower_than;
            // this.sales_target_greater_than = this.notification_trigger_list[0].sales_target_greater_than;
            // this.sales_forecast_lower_than = this.notification_trigger_list[0].sales_forecast_lower_than;
            // this.sales_forecast_greater_than = this.notification_trigger_list[0].sales_forecast_greater_than;
            // this.transactions_target_lower_than = this.notification_trigger_list[0].transactions_target_lower_than;
            // this.transactions_target_greater_than = this.notification_trigger_list[0].transactions_target_greater_than;
            // this.transactions_forecast_lower_than = this.notification_trigger_list[0].transactions_forecast_lower_than;
            // this.transactions_forecast_greater_than = this.notification_trigger_list[0].transactions_forecast_greater_than;

            // this.notification_type = this.notification_trigger_list[0].notification_type.map(el => {
            //   return el.id
            // })

            // let params = {
            //   outlets : this.notification_trigger_list[0].stores
            // };
            // this.getUsersForNotification(params);

            // this.store = this.notification_trigger_list[0].stores.map(el => {
            //   return el.id
            // })
          }
        })
        .catch(err => {
          console.log(err);
          this.is_notification_trigger_list_loading = false;
        });
    },

    // function to open set trigger dialog
    openSetTriggerDialog(){
      this.show_error_on_empty = false;
      this.set_trigger_dialog = true;
    },

    // function to close set trigger dialog
    handleClose(done) {
      this.set_trigger_dialog = false;
    },

    getNotificationTypeList() {
      RealTimeService.getNotificationType()
        .then(response => {
          this.notification_type_list = JSON.parse(response.data);
        })
        .catch(err => {
          console.log(err);
        });

      // RealTimeService.getLocation()
      //   .then(response => {
      //     console.log(JSON.parse(response.data));
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    },

    saveNotificationTrigger() {
      this.show_error_on_empty = true;
      this.$validator.validateAll().then(result => {
        if(result){
          let param = {
            sales_target_lower_than: this.sales_target_lower_than,
            sales_target_greater_than: this.sales_target_greater_than,
            sales_forecast_lower_than: this.sales_forecast_lower_than,
            sales_forecast_greater_than: this.sales_forecast_greater_than,
            transactions_target_lower_than: this.transactions_target_lower_than,
            transactions_target_greater_than: this.transactions_target_greater_than,
            transactions_forecast_lower_than: this.transactions_forecast_lower_than,
            transactions_forecast_greater_than: this.transactions_forecast_greater_than,
            recipients: this.recipients.map(e => { return { id: e } }),
            notification_type: this.notification_type.map(e => { return { id: e } }),
            frequency: this.notification_frequency,
            // stores: [{ id: "35bd84fa-69f3-4944-a1ef-1d4fdb69bf45" }]
            stores:  [{ id: this.location_for_trigger } ]
            // this.location_for_trigger.map(e => {return { id: e } })
          };

          RealTimeService.addNotificationType(param)
          .then(response => {
            if (response.status === 200) {

              this.set_trigger_dialog = false;

              //called get api to get updated notification list
              this.getAllNotificationList();

              this.$notify.success({
                title: "Success",
                message: 'Notification trigger saved successfully'
              });
              // this.notification_type_list = JSON.parse(response.data);
              // console.log(this.notification_type_list);
            }
          })
          .catch(err => {
            console.log(err);
            this.set_trigger_dialog = false;
          });
        }
      })


      // if (this.basics == "subregion") {
      //   param.subregions = this.selectedLocation.map(e => {
      //     return { id: e.id };
      //   });
      // } else if (this.basics == "country") {
      //   param.countries = this.selectedLocation.map(e => {
      //     return { id: e.id };
      //   });
      // } else if (this.basics == "region") {
      //   param.regions = this.selectedLocation.map(e => {
      //     return { id: e.id };
      //   });
      // } else if (this.basics == "outlet") {
      //   param.stores = this.selectedLocation.map(e => {
      //     return { id: e.id };
      //   });
      // }
    },

    editSetNotification(notification){
      // console.log('editSetNotification', notification);
      this.sales_target_lower_than = notification.sales_target_lower_than;
      this.sales_target_greater_than = notification.sales_target_greater_than;
      this.sales_forecast_lower_than = notification.sales_forecast_lower_than;
      this.sales_forecast_greater_than = notification.sales_forecast_greater_than;
      this.transactions_target_lower_than = notification.transactions_target_lower_than;
      this.transactions_target_greater_than = notification.transactions_target_greater_than;
      this.transactions_forecast_lower_than = notification.transactions_forecast_lower_than;
      this.transactions_forecast_greater_than = notification.transactions_forecast_greater_than;
      // this.recipients = notification.recipients.map(res=>{ return res.id });
      this.notification_type = notification.notification_type.map(res=> { return res.id });
      this.location_for_trigger = notification.stores[0].id;
      this.notification_frequency = notification.frequency;
      this.getUsersForNotification();
      this.openSetTriggerDialog();
    },

    deleteSetNotification(notification){
      let params = {
        notification_id: notification.id
      }

      RealTimeService.deleteNotification(params)
        .then(response => {
          if (response.status === 200) {

            //called get api to get updated notification list
            this.getAllNotificationList();

            this.$notify.success({
              title: "Success",
              message: 'Notification deleted successfully'
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getNotificationTriggersByStore(){
      // console.log(update.basics);
      // this.basics = update.basics;
      this.param = {
        outlets: [],
        // subcategories: [],
        // countries: [],
        // regions: [],
        // subregions: []
      };
      // this.selectedLocation = update.selected;
      // if (update.basics == "subregion") {
      //   this.param.subregions = update.selected.map(e => {
      //     return { id: e.id };
      //   });
      // } else if (update.basics == "country") {
      //   this.param.countries = update.selected.map(e => {
      //     return { id: e.id };
      //   });
      // } else if (update.basics == "region") {
      //   this.param.regions = update.selected.map(e => {
      //     return { id: e.id };
      //   });
      // } else if (update.basics == "outlet") {
      //   this.param.outlets = update.selected.map(e => {
      //     return { id: e.id };
      //   });

      // }
      let params = {
        outlets : this.store.map(e => {
                    return { id: e };
                  })
      };

      // this.param.outlets = this.store.map(e => {
      //   return { id: e };
      // });
      // this.$emit("changedData", this.param, update.basics);

      if(params.outlets.length){
        // this.getUsersForNotification(params);
      }
    },

    getUsersForNotification() {
      let params = {
        outlets : [{ id: this.location_for_trigger } ]
        // this.location_for_trigger.map(e => {return { id: e } })
      };

      RealTimeService.getUsersForNotification(params)
        .then(response => {
          if (response.status === 200) {
            this.users_list = JSON.parse(response.data);

            this.recipients = this.users_list.map(e => {
              return e.id
            })
            // console.log(this.users_list);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    clearSetTriggerForm(){
      this.sales_target_lower_than = '';
      this.sales_target_greater_than = '';
      this.sales_forecast_lower_than = '';
      this.sales_forecast_greater_than = '';
      this.transactions_target_lower_than = '';
      this.transactions_target_greater_than = '';
      this.transactions_forecast_lower_than = '';
      this.transactions_forecast_greater_than = '';
      this.recipients = [];
      this.notification_type = [];
      this.location_for_trigger = '';
      this.notification_frequency = '';
      this.users_list = [];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./Notifications.scss";
</style>
<style>
.Notifications .el-dialog{
  margin-top: 10vh!important;
}
.el-dialog__header {
  background: #32343d;
}
.el-dialog__title {
  color: white;
  font-size: 15px;
}
</style>
